/*LIBRARY*/
import React from "react";
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import SpinnerWhite from "../common_spinner/SpinnerWhite";

/*REDUX*/
import { actionPayment } from "../../App/actions/paymentActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class PaymentConfirmation extends Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
    this.state = {};
  }

  handleSubmit = () => {
    const { payment } = this.props.payment;
    const body = {
      payment_id: payment._id,
      status: "user_cancel",
    };
    let finalObject;
    finalObject = {
      body,
    };
    this.props.actionPayment(finalObject);
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props
    const { loadingProcess } = this.props.payment;

    //content
    const buttonContent = loadingProcess ? (
      <div className="button_block_tight" id="delete">
        <SpinnerWhite
          width={30}
          unik="loading_item_list"
          marginTop="0px"
          center={true}
          border={0.1}
        />
      </div>
    ) : (
      <button onClick={this.handleSubmit} className="button_block" id="delete">
        {dict["Cancel transaction"][language]}
      </button>
    );
    const content = (
      <div style={{ textAlign: "center" }}>
        <div style={{ marginBottom: "30px" }}>
          {dict["Are you sure to cancel the transaction"][language]}
        </div>
        {buttonContent}
      </div>
    );
    return <div>{content}</div>;
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
});

export default connect(mapStateToProps, { actionPayment })(PaymentConfirmation);
